import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { getMenuClassNames } from './Dropdown.styles'
import { DropdownProps } from './Dropdown.types'

/**
 *
 * @param open - If true, dropdown is open
 * @param onOpenChange - Handles open state
 * @param disabled - If true, disables trigger
 * @param triggerRef - Ref for trigger
 * @param trigger - Trigger element, usually a button, opens dropdown
 * @param children - Content of dropdown
 * @className - Class name for styling dropdown menu
 * @onContentScroll - Callback for scroll events on dropdown content
 */

export const Dropdown = ({
    open,
    onOpenChange,
    disabled,
    triggerRef,
    trigger,
    children,
    classNames,
    onContentScroll,
    ref,
    onPointerDownOutside,
    modal = false,
}: DropdownProps) => {
    return (
        <DropdownMenu.Root
            open={open}
            onOpenChange={onOpenChange}
            modal={modal}
        >
            <DropdownMenu.Trigger disabled={disabled} ref={triggerRef} asChild>
                {trigger}
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className={getMenuClassNames(classNames)}
                    style={{ zIndex: 'var(--z-select-in-modal)' }}
                    onScroll={onContentScroll}
                    ref={ref}
                    onPointerDownOutside={onPointerDownOutside}
                >
                    {children}
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    )
}
